var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#6481E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2136 18.2494L18.4952 23.1486L26.4774 18.2494L18.4952 4.5L10.2136 18.2494Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4954 4.5V23.1486L26.7869 18.2494L18.4954 4.5Z",
    fill: "#C0CCF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2136 19.8259L18.4952 31.5V24.7151L10.2136 19.8259Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.4952 14.488L10.2136 18.2497L18.4952 23.1488L26.7868 18.2497L18.4952 14.488Z",
    fill: "#8299EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4954 24.7151V31.5L26.7869 19.8259L18.4954 24.7151Z",
    fill: "#C0CCF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.a7b28e72dbe1710c8c448c8ee03f85f2.svg";
export { ForwardRef as ReactComponent };